export type TextSizes =
  | "extraLarge"
  | "large"
  | "regular"
  | "small"
  | "extraSmall"
  | "paragraph"
  | "paragraphLarge"
  | "paragraphSmall"
  | "paragraphXsmall"
  | "timestamp"
  | "subtitleSmall";
